import request from './request'

export const getPedigreeDetail = (id) => {
    return request({
        url: '/pedigree/getPedigreeDetail',
        method: 'POST',
        data: { id }
    })
}

export const savePedigreeDetail = (data) => {
    return request({
        url: '/pedigree/savePedigreeDetail',
        method: 'POST',
        data
    })
}
export const removePedigreeDetail = (pedigreeId, id) => {
    return request({
        url: '/pedigree/removePedigreeDetail',
        method: 'POST',
        data: {
            pedigreeId,
            id
        }
    })
}
